import { AvailableIconName } from '@/assets/icons';
import { Stack } from '@/components/layout';
import { SvgIcon } from '@/components/ui';
import Text from '@/components/ui/text/text';
import { CheckpointStatus } from '@/features/player-session/types/types';
import { createStyles, useScaling } from '@/hooks';
import { colors, ColorToken } from '@/theme/colors';
import { Activity } from 'react';
import { TouchableOpacity } from 'react-native';

export const TrackingStateView = ({
  label,
  icon,
  onPress,
  data,
  level,
  hideProgress = false,
}: {
  label: string;
  onPress?: () => void;
  icon: AvailableIconName;
  data?: playerSession.Badge;
  level: number;
  hideProgress?: boolean;
}) => {
  const { scale } = useScaling();
  const styles = useStyles();

  const totalCheckpoints = data?.checkpoints.length ?? 0;
  const completedCheckpoints =
    data?.checkpoints.reduce(
      (acc, curr) => acc + (curr.status === CheckpointStatus.Completed ? 1 : 0),
      0,
    ) ?? 0;
  const progressPercentage =
    totalCheckpoints > 0 ? (completedCheckpoints / totalCheckpoints) * 100 : 0;

  const progressCompleted = data?.badgeEarned ?? false;

  return (
    <TouchableOpacity activeOpacity={0.6} onPress={onPress}>
      <Stack
        width={scale(50)}
        gap={scale(4)}
        height={scale(66)}
        paddingX={scale(4)}
        paddingTop={scale(6)}
        borderRadius={4}
        borderWidth={1}
        borderColor={progressCompleted ? colors[`Level ${level}` as ColorToken] : colors['5']}
        paddingBottom={scale(11)}
        align="center">
        <Stack align="center" justify="center">
          <SvgIcon
            name={progressCompleted ? 'IcCompletedFill' : icon}
            size={progressCompleted ? scale(20) : scale(28)}
            color={colors[`Level ${level}` as ColorToken]}
          />
        </Stack>
        <Text
          variant="Font Inter/Body/Regular 16px"
          fontSize={scale(6)}
          lineHeight={scale(progressCompleted ? 11 : 12)}
          letterSpacing={scale(0)}
          fontWeight={!progressCompleted ? '400' : '600'}
          style={[styles.slideLabel, { color: colors[`Level ${level}` as ColorToken] }]}>
          {progressCompleted ? `${label} Completed` : label}
        </Text>
        <Activity mode={hideProgress || progressCompleted ? 'hidden' : 'visible'}>
          {!hideProgress && (
            <Stack backgroundColor={colors['4']} width={scale(36)} height={scale(4)}>
              <Stack
                width={`${progressPercentage}%`}
                height={'100%'}
                position="absolute"
                top={0}
                left={0}
                backgroundColor={colors[`Level ${level}` as ColorToken]}
              />
            </Stack>
          )}
        </Activity>
      </Stack>
    </TouchableOpacity>
  );
};

const useStyles = createStyles(() => ({
  slideLabel: {
    color: colors['10'],
    textAlign: 'center',
    width: '100%',
  },
}));
